require('./bootstrap');

import '@fortawesome/fontawesome-free/css/all.min.css';
import './vendor/laravel-core/sortableTable.js'

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
